// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'POST',
    endpoint: '/api/dipendenti',
    requestBody: '{societaId,nome,cognome,codiceFiscale,dataNascita,residenza,telefono,email,dataAssunzione,tipoContratto,dataFineContratto,mansione,ccnl,ral}',
    response: '{dipendente:{id,...}}'
  },
  {
    method: 'GET',
    endpoint: '/api/dipendenti?societaId&stato&tipoContratto&search',
    requestBody: null,
    response: '{dipendenti:[{id,nome,cognome,codiceFiscale,mansione,tipoContratto,dataFineContratto,scadenzaFlag,stato}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
